import LazyLoad from "vanilla-lazyload";
import lazyLoad from "./components/lazyLoad";
import ScrollToTop from "./components/scrollToTop";
import MobileBurgerMenu from "./components/mobileBurgerMenu";
import loadGame from "./components/scrollTo";

document.addEventListener( 'DOMContentLoaded', function () {

	lazyLoad();

	let myLazyLoad = new LazyLoad();

	ScrollToTop();

	MobileBurgerMenu();

	// iframe on click
	loadGame();
} );